import Grid from '@mui/material/Grid2';
import { HepsijetSettings } from './HepsijetSettings';
import { ArasSettings } from './ArasSettings';
import { MngSettings } from './MngSettings';

export const ShipmentSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <HepsijetSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <MngSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <ArasSettings />
      </Grid>
    </Grid>
  );
};
